import { useMediaPropsActive } from "./useMedia";
function useProps(props, opts) {
  return useMediaPropsActive(props, {
    expandShorthands: !opts?.disableExpandShorthands,
    resolveValues: opts?.resolveValues
  });
}
export {
  useProps
};
//# sourceMappingURL=useProps.js.map
